import React, { useState, useEffect } from "react";
import { RiUserAddFill } from "react-icons/ri";
import { TbListDetails } from "react-icons/tb";
import { IoInformationCircle } from "react-icons/io5";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import "./add-emp.css";
import { Button, Alert } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AddEmp = () => {
  const [role, setRole] = useState(null);
  const [department, setDepartment] = useState(null);
  const [departmentType, setDepartmentType] = useState(null);
  const [gender, setGender] = useState(null);
  const [country, setCountry] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [status, setStatus] = useState(null);
  const [maritalstatus, setMaritalStatus] = useState(null);
  const [countries, setCountries] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [departmentTypes, setDepartmentTypes] = useState([]);
  const [profilePhoto, setprofilePhoto] = useState(null);
  const [idCardFront, setIdCardFront] = useState(null);
  const [idCardBack, setIdCardBack] = useState(null);
  const [cv, setCv] = useState(null);
  const [pastWorkCertificate, setpastWorkCertificate] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("success");

  useEffect(() => {
    fetch("https://restcountries.com/v3.1/all?fields=cca2,name")
        .then((response) => response.json())
        .then((data) => {
          const countryOptions = data
              .filter(c => c.cca2 && c.name?.common)
              .map((country) => ({
                value: country.cca2,
                label: country.name.common,
              }));
          setCountries(countryOptions);
        })
        .catch((error) => console.error("Error fetching countries:", error));
  }, []);

  // Fetch department list
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get(
          "https://backend.ems.hiradentallab.com/api/departments"
        );
        const departmentOptions = response.data.map((department) => ({
          value: department._id,
          label: department.name,
          types: department.types || []
        }));
        setDepartmentOptions(departmentOptions);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };
    fetchDepartments();
  }, []);

  // Handle department change to fetch types
  const handleDepartmentChange = (selectedDepartment) => {
    setDepartment(selectedDepartment);
    setDepartmentType(null); // Reset department type when department changes

    if (selectedDepartment && selectedDepartment.types) {
      const typeOptions = selectedDepartment.types.map(type => ({
        value: type,
        label: type
      }));
      setDepartmentTypes(typeOptions);
    } else {
      setDepartmentTypes([]);
    }
  };

  const navigate = useNavigate();

  // Handle file uploads
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    // Populate form data
    formData.append("name", e.target.name.value);
    formData.append("username", e.target.username.value);
    formData.append("password", e.target.password.value);
    formData.append("role", role?.value || "employee");
    formData.append("email", e.target.email.value);
    formData.append("department", department?.value || "");
    formData.append("departmentType", departmentType?.value || "");
    formData.append("joinDate", startDate);
    formData.append("birthday", e.target.birthday.value);
    formData.append("gender", gender?.value || "M");
    formData.append("maritalstatus", maritalstatus?.value || "Single");
    formData.append("status", status?.value || "active");
    formData.append("phone", e.target.phone.value);
    formData.append("city", e.target.city.value);
    formData.append("country", country?.value || "");
    formData.append("address", e.target.address.value);
    formData.append("workExperience", e.target.workExperience.value);
    formData.append("workDescription", e.target.workDescription.value);
    formData.append("salary", e.target.salary.value);
    formData.append("jobTitle", e.target.jobTitle.value);
    if (profilePhoto) formData.append("profilePhoto", profilePhoto);
    if (idCardFront) formData.append("idCardFront", idCardFront);
    if (idCardBack) formData.append("idCardBack", idCardBack);
    if (cv) formData.append("cv", cv);
    if (pastWorkCertificate) formData.append("pastWorkCertificate", pastWorkCertificate);

    try {
      const response = await axios.post(
        "https://backend.ems.hiradentallab.com/api/user/create",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      setAlertMessage("Employee added successfully!");
      setAlertVariant("success");
      setShowAlert(true);
      resetForm(); // Reset form fields after submission
      // Redirect to the emp-info page after 3 seconds
      setTimeout(() => {
        navigate("/emp-info"); // Navigate to emp-info page
      }, 3000);
    } catch (error) {
      setAlertVariant("danger"); // Change alert type to danger
      if (
        error.response &&
        error.response.data.message === "User already exists."
      ) {
        setAlertMessage("Error: User already exists.");
      } else {
        setAlertMessage("Error adding employee. User already exists.");
      }
      setShowAlert(true);
      // Set timeout to hide alert after 3 seconds
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
      console.error(
        "Error adding employee:",
        error.response?.data || error.message
      );
    }
  };

  // Reset form fields
  const resetForm = () => {
    setprofilePhoto();
    setRole(null);
    setDepartment(null);
    setDepartmentType(null);
    setGender(null);
    setCountry(null);
    setStartDate("");
    setStatus(null);
    setMaritalStatus(null);
    setIdCardFront(null);
    setIdCardBack(null);
    setCv(null);
    setpastWorkCertificate(null);
  };

  // Dropdown options
  const roleOptions = [
    { value: "Employee", label: "Employee" },
    { value: "Admin", label: "Admin" },
    { value: "HR", label: "HR" },
    { value: "Accounts", label: "Accounts" }
  ];

  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];

  const maritalstatusOptions = [
    { value: "Single", label: "Single" },
    { value: "Married", label: "Married" },
  ];

  const statusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Un Active" },
  ];

  const handleFileChange = (event, setState) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      setState(file); // Update the state with the selected file
    }
  };

  return (
    <div className="container-fluid">
      <div className="emp-information-container">
        <h1 style={{ color: "#0353a4",fontSize: "2rem",marginTop:"65px"}}>
          <RiUserAddFill /> Add Employee
        </h1>
        <hr className="section-divider" />
        <h1 style={{ color: "#0353a4", textAlign: "left", fontSize: "2rem" }}>
          <TbListDetails /> Login Details
        </h1>
        <hr className="section-divider" />
      </div>

      <Form onSubmit={handleSubmit} className="add-emp-form">
        <div className="add-emp-container">
          {showAlert && (
            <Alert
              variant={alertVariant}
              onClose={() => setShowAlert(false)}
              dismissible
            >
              {alertMessage}
            </Alert>
          )}

          {/* Login Details Section */}
          <Row className="mb-3">
            <Form.Group as={Col} xs={12} md={5} controlId="formGridName">
              <Form.Label>
                Name<span className="required">*</span>:
              </Form.Label>
              <Form.Control
                type="text"
                name="name"
                required
                placeholder="Enter Your Name"
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={5} controlId="formGridPassword">
              <Form.Label>
                Password<span className="required">*</span>:
              </Form.Label>
              <Form.Control
                type="password"
                name="password"
                required
                placeholder="Enter Password"
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={5} controlId="formGridUserName">
              <Form.Label>
                UserName <span className="required">*</span>:
              </Form.Label>
              <Form.Control
                type="text"
                name="username"
                required
                placeholder="Enter Your Username"
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={5} controlId="formGridRole">
              <Form.Label>Role <span className='required'>*</span>:</Form.Label>
              <Select
                options={roleOptions}
                value={role}
                name="role"
                onChange={setRole}
                placeholder="--Select Role--"
              />
            </Form.Group>
          </Row>
        </div>

        {/* Employee Information Section */}
        <div>
          <h1
            style={{
              color: "#0353a4",
              textAlign: "left",
              fontSize: "2rem",
              marginTop: "30px",
            }}
          >
            <IoInformationCircle /> Employee Information
          </h1>
          <hr className="section-divider" />
        </div>

        <div className="add-emp-container">
          <Row className="mb-3">
            <Form.Group as={Col} xs={12} md={5} controlId="formGridDepartment">
              <Form.Label> Department </Form.Label>
              <Select
                options={departmentOptions}
                value={department}
                name="department"
                onChange={handleDepartmentChange}
                placeholder="--Select Department--"
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={5} controlId="formGridDepartmentType">
              <Form.Label> Department Type </Form.Label>
              <Select
                options={departmentTypes}
                value={departmentType}
                name="departmentType"
                onChange={setDepartmentType}
                placeholder={departmentTypes.length > 0 ? "--Select Type--" : "Select a department first"}
                isDisabled={departmentTypes.length === 0}
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={5} controlId="formGridStartDate">
              <Form.Label>
                Join Date <span className="required">*</span> :
              </Form.Label>
              <Form.Control
                type="date"
                name="joinDate"
                required
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} xs={12} md={5} controlId="formGridJobTitle">
              <Form.Label>
                Job Title <span className="required">*</span> :
              </Form.Label>
              <Form.Control
                type="text"
                name="jobTitle"
                required
                placeholder="Enter Your Job Title"
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={5} controlId="formGridDOB">
              <Form.Label>
                Date Of Birth <span className="required">*</span> :
              </Form.Label>
              <Form.Control type="date" name="birthday" required />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} xs={12} md={5} controlId="formGridGender">
              <Form.Label>Gender </Form.Label>
              <Select
                options={genderOptions}
                value={gender}
                name="gender"
                onChange={setGender}
                placeholder="--Select Gender--"
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={5} controlId="formGridStatus">
              <Form.Label>Status</Form.Label>
              <Select
                options={statusOptions}
                value={status}
                name="status"
                onChange={setStatus}
                placeholder="--Select Status--"
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={5} controlId="formGridStatus">
              <Form.Label>Martial Status</Form.Label>
              <Select
                options={maritalstatusOptions}
                value={maritalstatus}
                name="marital-status"
                onChange={setMaritalStatus}
                placeholder="--Select Status--"
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Col xs={12} md={5}>
              <Form.Group controlId="formGridCountry">
                <Form.Label>Country <span className="required">*</span> :</Form.Label>
                <Select
                  name="country"
                  options={countries}
                  className="basic-single"
                  classNamePrefix="select"
                  required
                />
              </Form.Group>
            </Col>

            <Form.Group as={Col} xs={12} md={5} controlId="formGridExperience">
              <Form.Label>
                Experience<span className="required">*</span> :
              </Form.Label>
              <Form.Control
                type="text"
                name="workExperience"
                required
                placeholder="Enter Your Experience"
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} xs={12} md={5} controlId="formGridPhone">
              <Form.Label>
                Phone<span className="required">*</span> :
              </Form.Label>
              <Form.Control
                type="tel"
                name="phone"
                required
                placeholder="Enter Your Phone Number"
              />
            </Form.Group>

            <Form.Group
              as={Col}
              xs={12}
              md={5}
              controlId="formGridWorkDescription"
            >
              <Form.Label>
                Work Description <span className="required">*</span> :
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="workDescription"
                required
                placeholder="Describe Your Work"
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} xs={12} md={5} controlId="formGridEmail">
              <Form.Label>
                Email <span className="required">*</span> :
              </Form.Label>
              <Form.Control
                type="email"
                name="email"
                required
                placeholder="Enter Your Email"
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={5} controlId="formGridCity">
              <Form.Label>
                City <span className="required">*</span> :
              </Form.Label>
              <Form.Control
                type="text"
                name="city"
                required
                placeholder="Enter Your City"
              />
            </Form.Group>
          </Row>

          <Row>
            <Form.Group as={Col} xs={12} md={5} controlId="formGridAddress">
              <Form.Label>
                Address <span className="required">*</span> :
              </Form.Label>
              <Form.Control
                type="text"
                name="address"
                required
                placeholder="Enter Your Address"
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={5} controlId="formGridSalary">
              <Form.Label>
                Salary <span className="required">*</span> :
              </Form.Label>
              <Form.Control
                type="number"
                name="salary"
                required
                placeholder="Enter Salary"
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} xs={12} md={5} controlId="formGridProfilePhoto">
              <Form.Label>Profile Photo:</Form.Label>
              <Form.Control
                type="file"
                name="profilePhoto"
                accept=".png, .jpg, .jpeg"
                onChange={(e) => handleFileChange(e, setprofilePhoto)}
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={5} controlId="formGridIDCardFront">
              <Form.Label>ID Card Front:</Form.Label>
              <Form.Control
                type="file"
                name="idCardFront"
                accept=".pdf"
                onChange={(e) => handleFileChange(e, setIdCardFront)}
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={5} controlId="formGridIDCardBack">
              <Form.Label>ID Card Back:</Form.Label>
              <Form.Control
                type="file"
                name="idCardBack"
                accept=".pdf"
                onChange={(e) => handleFileChange(e, setIdCardBack)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} xs={12} md={5} controlId="formGridCV">
              <Form.Label>CV:</Form.Label>
              <Form.Control
                type="file"
                name="cv"
                accept=".pdf"
                onChange={(e) => handleFileChange(e, setCv)}
              />
            </Form.Group>

            <Form.Group
              as={Col}
              xs={12}
              md={5}
              controlId="formGridPastWorkCertificate"
            >
              <Form.Label>Past Work Certificate:</Form.Label>
              <Form.Control
                type="file"
                name="pastWorkCertificate"
                accept=".pdf"
                onChange={(e) => handleFileChange(e, setpastWorkCertificate)}
              />
            </Form.Group>
          </Row>

          <Button variant="primary" type="submit">
            Add Employee
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default AddEmp;